import React, { useState } from 'react';
import insuranceData from './insurance-data-documents/InsuranceData-Business_v03a-Images-stock_v03-DocLinks.json';

type InsuranceCategory = {
  id: string;
  title: string;
  description: string;
  benefits: string[];
  example: string;
  imageUrls: {
    url: string;
    altText: string;
  }[];
  jsonDocument: string;
};


const InsuranceLookup: React.FC = () => {
  const [queryId, setQueryId] = useState('');
  const [result, setResult] = useState<InsuranceCategory | null>(null);

  const handleSearch = () => {
    const match = insuranceData.businessServices.find(
      (item: InsuranceCategory) => item.id.toLowerCase() === queryId.toLowerCase()
    );
    setResult(match || null);
  };

  return (
    <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
      <h2>Business Insurance Category Lookup</h2>

      <div style={{ marginBottom: '1rem' }}>
        <input
          type="text"
          value={queryId}
          onChange={(e) => setQueryId(e.target.value)}
          placeholder="Enter ID (e.g., BIZ-004)"
          style={{ padding: '0.5rem', width: '60%' }}
        />
        <button onClick={handleSearch} style={{ padding: '0.5rem 1rem', marginLeft: '1rem' }}>
          Search
        </button>
      </div>

      {result ? (
        <div>
          <h3>{result.title}</h3>
          <p><strong>Description:</strong> {result.description}</p>
          <p><strong>Example:</strong> {result.example}</p>
          <ul>
            {result.benefits.map((benefit, idx) => (
              <li key={idx}>{benefit}</li>
            ))}
          </ul>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            {result.imageUrls.map((img, idx) => (
              <img
                key={idx}
                src={img.url}
                alt={img.altText}
                style={{ width: '200px', borderRadius: '4px' }}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = 'https://via.placeholder.com/200?text=No+Image';
                }}
              />
            ))}
          </div>
        </div>
      ) : (
        queryId && <p style={{ color: 'red' }}>No matching insurance category found.</p>
      )}
    </div>
  );
};

export default InsuranceLookup;
